import React, { useMemo, useState } from "react";
import { Alert } from "antd";
import { createForm, onFieldReact, onFieldValueChange } from "@formily/core";
import {
  Radio,
  FormItem,
  Input,
  Submit,
  DatePicker,
  Space,
  FormButtonGroup,
} from "@formily/antd";
import { Button, Card, Divider, Modal, Table } from "antd";
import "antd/lib/button/style";
import { FormProvider, Field, VoidField } from "@formily/react";
import json2form from "../../unit/json2form";
import { request, requestkind } from "../../unit/request";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import * as datasource from "../../conf/datasource";
import { GuaranteeSummary } from "../../components/Summary";
import { PlusSquareOutlined } from "@ant-design/icons";

const GuaranteeWithdrawPost = () => {
  const form = useMemo(
    () =>
      createForm({
        validateFirst: true,
        effects() {
          onFieldValueChange("CreditType", async (field) => {
            const PartnerNumber = field.query("PartnerNumber").value();
            // console.log(v)
            if (
              field.value === "BankGuarantee" ||
              field.value === "CorpGuarantee"
            ) {
              set_show_select_btn(true);
              const json = await request(
                {
                  PartnerNumber: PartnerNumber,
                  CreditType: field.value,
                },
                {},
                requestkind.GuaranteeStatement.SearchAdditionGuarantee
              );
              console.log(json);
              const { IsSuccess, Data } = json;
              if (IsSuccess) {
                console.log(Data);
                delete Data.CreditType;
                Data.map((data: any) => {
                  data["RefDaid"] = data["FlowId"];
                });
                setItems(Data);
              }
            }

            //申请类型是保证金的时候
            if (field.value === "Deposit") {
              set_show_select_btn(false);

              // const arr = ["Amount", "BankAccount", "BankName", "Comment"]
              // // eslint-disable-next-line array-callback-return
              // arr.map((key: string) => {
              //     form.setFieldState(key, (state) => {
              //         state.value = ""
              //         state.disabled = false
              //     })
              // })

              // form.setState({
              //     disabled: false
              // })
            } else {
              //切换银行保函和公司保函时，清除相关字段数据
              // eslint-disable-next-line array-callback-return
              [
                "Comment",
                "Guarantor",
                "Amount",
                "GuaranteeEndDate",
                "GuaranteeStartDate",
                "GuaranteeNumber",
                "Website",
              ].map((key: string) => {
                form.setFieldState(key, (state) => {
                  state.value = "";
                  // state.disabled = false
                });
              });
            }

            if (field.value === "BankGuarantee") {
            }

            if (field.value === "CorpGuarantee") {
              form.setFieldState("Website", (state) => {
                state.value = "";
                // state.disabled = false
              });
            }
            // form.setFieldState('FirstYearAmount', (state) => {
            //     console.log('state', state)
            //     state.display = field.value === "1" ? "none" : "visible"
            // })
          });

          onFieldReact("Website", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType === "CorpGuarantee" ? false : true;
          });
          onFieldReact("BankAccount", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType === "Deposit" ? false : true;
          });
          onFieldReact("BankName", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType === "Deposit" ? false : true;
          });

          //
          // onFieldReact('ChannelAgreementNumber', (field) => {
          //     const CreditType = field.query('CreditType').value()
          //     field.hidden = (CreditType !== "Deposit") ? false : true
          // })
          // onFieldReact('ChannelAgreementName', (field) => {
          //     const CreditType = field.query('CreditType').value()
          //     field.hidden = (CreditType !== "Deposit") ? false : true
          // })
          onFieldReact("Guarantor", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType !== "Deposit" ? false : true;
          });
          onFieldReact("GuaranteeNumber", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType !== "Deposit" ? false : true;
          });
          //
          onFieldReact("GuaranteeStartDate", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType !== "Deposit" ? false : true;
          });
          onFieldReact("GuaranteeEndDate", (field) => {
            const CreditType = field.query("CreditType").value();
            field.hidden = CreditType !== "Deposit" ? false : true;
          });
        },
      }),
    []
  );
  // const form = createForm({

  // })

  const [items, setItems] = useState<any[]>([]);
  const history = useHistory();
  const [is_show_select_info, set_is_show_select_info] =
    useState<boolean>(false);
  const [errs, setErrs] = useState<any>({});
  const [showErr, setShowErr] = useState(false);
  const [show_select_btn, set_show_select_btn] = useState<boolean>(false);
  const [partnerNumber, setPartnerNumber] = useState<string>();
  const post = async (data: any) => {
    setLoading(true);
    const formdata = json2form(data);
    const json = await request(
      formdata,
      null,
      requestkind.GuaranteeWithdraw.Apply
    );
    console.log(json);
    setLoading(false);
    const { IsSuccess, Msg, Data, errors } = json;
    if (IsSuccess) {
      const { FlowID } = Data;
      Modal.success({
        title: "申请成功！",
        content: `FlowID:${FlowID}`,
        onOk: () => {
          console.log("goto ");
          history.push("/guaranteeWithdraw");
        },
      });
      // FormDialog('申请成功！', () => {
      //     return (
      //         <p>FlowID:{FlowID}</p>
      //     )
      // }).open()
    } else {
      // FormDialog('错误！', () => {
      //     return (
      //         <p>Msg</p>
      //     )
      // }).open()
      if (Msg) {
        Modal.error({
          title: "错误！",
          content: Msg,
        });
      }
      if (errors) {
        setErrs(errors);
        setShowErr(true);
      }
      setLoading(false);
    }
  };
  //进入页面，先获得当前的ParterInfo
  const getCurrentParterInfo = async () => {
    try {
      console.log("getting...");
      const json = await request(
        null,
        null,
        requestkind.Partner.CurrentParterInfo
      );
      const { PartnerNumber, PartnerName } = json.Data;
      console.log(json, PartnerNumber, PartnerName);
      form.setFieldState("PartnerNumber", (state) => {
        state.value = PartnerNumber;
      });
      form.setFieldState("PartnerName", (state) => {
        state.value = PartnerName;
      });
      setPartnerNumber(PartnerNumber);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getCurrentParterInfo();
  }, []);
  const setform = (data: any) => {
    console.log("setform");
    delete data.CreditType;
    form.setInitialValues(data);
  };
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div>
      <Modal
        width="90%"
        title="请选择"
        visible={is_show_select_info}
        onOk={() => {
          set_is_show_select_info(false);
        }}
        onCancel={() => {
          set_is_show_select_info(false);
        }}
      >
        <Table
          dataSource={items}
          columns={[
            {
              title: "流水号",
              key: "FlowId",
              dataIndex: "FlowId",
            },
            {
              title: "金额",
              key: "Amount",
              dataIndex: "Amount",
              render: (amount: number) => {
                return <span>{amount.toLocaleString()}</span>;
              },
            },
            {
              title: "保函编号",
              key: "GuaranteeNumber",
              dataIndex: "GuaranteeNumber",
            },
            {
              title: "保函开始时间",
              key: "GuaranteeStartDate",
              dataIndex: "GuaranteeStartDate",
              render: (time: string) => {
                return <span>{time.split(" ")[0]}</span>;
              },
            },
            {
              title: "保函结束时间",
              key: "GuaranteeEndDate",
              dataIndex: "GuaranteeEndDate",
              render: (time: string) => {
                return <span>{time.split(" ")[0]}</span>;
              },
            },
            {
              title: "操作",
              key: "FlowId",
              dataIndex: "FlowId",
              render: (x: any) => {
                return (
                  <Button
                    onClick={() => {
                      const select_items = items.filter((value) => {
                        return value.FlowId === x;
                      });
                      setform(select_items[0]);
                      set_is_show_select_info(false);
                      form.setState({
                        disabled: true,
                      });
                      form.setFieldState("CreditType", (state) => {
                        state.disabled = false;
                      });
                      form.setFieldState("Comment", (state) => {
                        state.disabled = false;
                      });
                    }}
                  >
                    选择
                  </Button>
                );
              },
            },
            // {
            //     title:'合同名称',
            //     key:'ChannelAgreementName',
            //     dataIndex:'ChannelAgreementName'
            // }
          ]}
        />

        {/* {items.map((item: any, index: number) => {
                    return (
                        <div key={index} onClick={() => {
                            setform(item)
                            set_is_show_select_info(false)
                        }}>
                            <p>{item.ChannelAgreementName}</p>
                            <p>{item.FlowId}</p>
                            <p>{item.CreateTime}</p>
                            
                            <Divider dashed />
                        </div>
                    )
                })} */}
      </Modal>
      <Modal
        title="错误提示"
        visible={showErr}
        onOk={() => {
          setShowErr(false);
        }}
        onCancel={() => {
          setShowErr(false);
        }}
      >
        {(() => {
          const data: any = [];
          let i = 0;
          for (const key in errs) {
            i++;
            const err = errs[key];
            data.push({
              key: i,
              keyName: key,
              value: err,
            });
          }
          return (
            <Table
              pagination={false}
              dataSource={data}
              columns={[
                {
                  title: "字段名称",
                  dataIndex: "keyName",
                  key: "keyName",
                },
                {
                  title: "错误描述",
                  dataIndex: "value",
                  key: "value",
                },
              ]}
            />
          );
        })()}
      </Modal>
      <Card bordered={false}>
        <Alert
          message="为确保资金汇划安全，防止保证金退还过程可能出现的错误，请您正确填写银行账号、开户行信息。"
          type="warning"
          showIcon
          closable
        />
      </Card>
      {partnerNumber && (
        <Card bordered={false}>
          <GuaranteeSummary partnerNumber={partnerNumber} />
        </Card>
      )}

      <Card bordered={false}>
        <FormProvider form={form}>
          <Field
            name="PartnerNumber"
            title="合作伙伴编号"
            required
            display="hidden"
            validator={{ maximum: 20 }}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="PartnerName"
            title="合作伙伴名称"
            required
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="RefDaid"
            title="关联的增加保函流水号"
            required
            decorator={[FormItem]}
            // hidden={true}
            display="hidden"
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="CreditType"
            title="申请类型"
            required
            dataSource={datasource.CreditType}
            initialValue={datasource.CreditType[0].value}
            decorator={[FormItem]}
            component={[
              Radio.Group,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="PartnerType"
            title="使用类别"
            required
            hidden={true}
            dataSource={datasource.PartnerType}
            initialValue="LSP"
            decorator={[FormItem]}
            component={[
              Radio.Group,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="Website"
            title="网址"
            required
            decorator={[FormItem]}
            disabled
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="FlowId"
            title="流水号"
            // required
            decorator={[FormItem]}
            display="hidden"
            // hidden={true}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <VoidField
            name="select"
            decorator={[
              FormItem,
              {
                asterisk: true,
                feedbackLayout: "none",
              },
            ]}
            component={[Space, {}]}
          >
            <Field
              name="GuaranteeNumber"
              title="保函编号"
              required
              decorator={[FormItem]}
              component={[
                Input,
                {
                  style: {
                    width: 300,
                  },
                },
              ]}
            />

            <Button
              icon={<PlusSquareOutlined />}
              onClick={() => {
                set_is_show_select_info(true);
              }}
              style={{
                marginTop: "-22px",
                display: show_select_btn ? "block" : "none",
              }}
            ></Button>
          </VoidField>

          <Field
            name="GuaranteeStartDate"
            title="保函有效期开始时间"
            required
            decorator={[FormItem]}
            component={[
              DatePicker,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="GuaranteeEndDate"
            title="保函有效期结束时间"
            required
            decorator={[FormItem]}
            component={[
              DatePicker,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="Amount"
            title="提取金额"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="BankAccount"
            title="银行账号"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="BankName"
            title="开户行"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="Guarantor"
            title="担保方"
            required
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="Comment"
            title="备注"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <Field
            name="ChannelAgreementNumber"
            title="保函合同编号"
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="ChannelAgreementName"
            title="保函合同名称"
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />

          <FormButtonGroup
            style={{
              marginLeft: "180px",
            }}
          >
            <Submit
              disabled={loading}
              onSubmit={(values) => {
                console.log(values);
                post(values);
              }}
            >
              {loading ? "正在提交" : "提交"}
            </Submit>
            <span
              style={{
                color: "#f00",
              }}
            >
              保证金提取时间：2、5、8、11月
            </span>
          </FormButtonGroup>
        </FormProvider>
      </Card>
    </div>
  );
};
export default GuaranteeWithdrawPost;
